(function () {
  var root = document.querySelector('[data-mood-board]');
  if (!root) return;

  var API_BASE = (root.getAttribute('data-mb-api-base') || '').replace(/\/$/, '');
  var CUSTOMER_ID = root.getAttribute('data-mb-customer-id');
  var PROXY_PATH = root.getAttribute('data-mb-proxy-path');
  var HOME_DECOR_HANDLE = 'home-decor-collection';
  var UPGRADE_URL = '/products/modern-studio-ai-plus';

  if (window.MSGProjects) window.MSGProjects.setCustomer(CUSTOMER_ID);

  var STYLES = {
    modern: { label: 'Modern', collection: 'style-modern',
      colors: ['#1C1C1E', '#F5F3EF', '#8C8C88', '#C9A35F', '#3A3A3C'],
      story: "Modern style favors clean lines, uncluttered surfaces, and a neutral base of black, white, and warm grey, with brass or gold accents adding a touch of warmth. Materials tend toward smooth woods, metal, and glass rather than heavy texture." },
    japandi: { label: 'Japandi', collection: 'style-japandi',
      colors: ['#EDE6DA', '#A9906F', '#5C6B57', '#2B2620', '#D8CDBC'],
      story: "Japandi blends Japanese minimalism with Scandinavian warmth — think pale oak, soft neutrals, and matte black accents. The palette stays quiet and earthy, letting natural wood grain and simple silhouettes do the talking." },
    'organic-modern': { label: 'Organic Modern', collection: 'style-organic-modern',
      colors: ['#E8E2D4', '#7C8B6F', '#B08D6A', '#FFFFFF', '#4A4438'],
      story: "Organic Modern pairs clean modern shapes with natural materials like rattan, linen, and light wood, kept soft with warm creams and muted greens. It feels calm and grounded rather than sleek or cold." },
    scandinavian: { label: 'Scandinavian', collection: 'style-scandinavian',
      colors: ['#FAF9F6', '#D9C8A9', '#A9B4A6', '#2E2C29', '#E3DCCF'],
      story: "Scandinavian style leans on light woods, soft neutrals, and gentle greys and greens for a bright, airy feel. Simplicity and function come first, with texture like wool and linen adding warmth to an otherwise pared-back palette." },
    industrial: { label: 'Industrial', collection: 'style-industrial',
      colors: ['#2B2B2B', '#6E6259', '#8A3324', '#D9D2C7', '#403C36'],
      story: "Industrial style embraces raw materials — blackened metal, reclaimed wood, and exposed textures — against a deep charcoal and rust-toned palette. It's meant to feel a little unfinished and utilitarian, in a good way." },
    'mid-century': { label: 'Mid-Century', collection: 'style-mid-century',
      colors: ['#D97B45', '#3E5C50', '#E8C468', '#F2EBDD', '#5C4033'],
      story: "Mid-Century style mixes warm walnut tones with punches of mustard, teal, and burnt orange, favoring tapered legs and gentle curves. The palette is bold but earthy, never cold." },
    minimalist: { label: 'Minimalist', collection: 'style-minimalist',
      colors: ['#FFFFFF', '#E8E8E6', '#B5B5B0', '#1A1A1A', '#D6D6D0'],
      story: "Minimalist style strips things back to essentials — mostly white, off-white, and grey, with a single dark accent for contrast. Every piece earns its place; nothing is purely decorative." },
    coastal: { label: 'Coastal', collection: 'style-coastal',
      colors: ['#F4F1EA', '#A9C4D1', '#3F5F6E', '#D9C8A0', '#7C9A92'],
      story: "Coastal style uses soft blues, sandy neutrals, and driftwood tones to evoke a relaxed, beachy feel. Woven textures like rattan and jute bring in natural warmth without heaviness." },
    farmhouse: { label: 'Farmhouse', collection: 'style-farmhouse',
      colors: ['#F7F3EA', '#6B7561', '#8B5E3C', '#2E2A24', '#D8CBB5'],
      story: "Farmhouse style combines warm wood tones with soft whites and muted greens, favoring a lived-in, welcoming feel over polish. Natural materials and slightly worn finishes are part of the charm." },
    traditional: { label: 'Traditional', collection: 'style-traditional',
      colors: ['#5A2E2C', '#C9A66B', '#2D3B45', '#EDE3D3', '#7A2E2E'],
      story: "Traditional style leans on rich, warm tones — deep reds, navy, and warm wood — paired with classic silhouettes and detailed finishes. It feels formal and layered rather than minimal." },
    luxury: { label: 'Luxury', collection: 'style-luxury',
      colors: ['#0F0F0F', '#C9A227', '#F5F0E8', '#3B2F2F', '#8A7B6C'],
      story: "Luxury style uses a dramatic dark base lifted by gold or brass accents and rich neutral textiles. Materials skew toward marble, velvet, and polished metal for a refined, high-contrast feel." },
    bohemian: { label: 'Bohemian', collection: 'style-bohemian',
      colors: ['#A63A3A', '#D9A441', '#4E6E58', '#5C3A54', '#E8D9BE'],
      story: "Bohemian style layers warm terracotta, mustard, and deep green with varied textures — woven, embroidered, natural fiber — for a collected, eclectic feel. Mixing pattern and color is part of the point." }
  };

  var WALL_ART_KEYWORDS = ['wall art', 'canvas art', 'framed art', 'art print'];
  var DECOR_SLOT_NAMES = ['Wall Art', 'Table Lamp', 'Lighting', 'Decorative Accent'];

  var FURNITURE_EXCLUDE = ['bookcase', 'bookshelf', 'dresser', 'nightstand', 'bed frame', 'platform bed', 'desk', 'office chair', 'sofa', 'sectional', 'dining table'];
  var ACCESSORY_STORAGE_EXCLUDE = ['basket', 'bin', 'organizer', 'caddy', 'jar', 'dispenser', 'tray', 'hamper'];

  /* ==========================================================================
     THE FOUNDATION — room-by-room priority rules (Sep 28, 2026)
     Each room's anchor piece is chosen from an ordered list. The first level
     with an in-stock piece in the selected style wins:
       Living Room : sofa -> accent chair -> coffee table
       Bedroom     : bed frame -> headboard -> dresser -> nightstand
       Kitchen     : dining set -> dining table -> dining chairs -> bar stools
                     (Dining Room collection first, then titles)
       Home Office : desk -> office chair -> bookcase
       Outdoor     : patio set -> patio sofa -> patio chair -> outdoor table
     A product qualifies when it is in the level's category collection OR its
     title names the piece — and never when its title names a look-alike
     (e.g. "console table behind sofa", "sofa cover", "coffee table books").
     Matching is on title + product type only (not tags), on whole words.
     If nothing in the style qualifies at any level, the board falls back to
     the category collections (any style) and says so on the card, rather
     than showing an unrelated piece. Nothing here is AI — it is rule-based.
     ========================================================================== */
  /* Look-alikes: only checked for pieces matched by title keyword. A piece
     that sits in the level's category collection is trusted as-is (so a
     "Sofa with Bolster Pillows" or "Wooden Leg" loveseat still counts). */
  var FOUNDATION_LOOKALIKES = ['console', 'sofa table', 'couch table', 'behind sofa', 'behind the sofa', 'behind couch', 'behind the couch', 'end table', 'side table', 'pillow cover', 'pillowcase', 'cushion cover', 'throw pillow', 'pillows for', 'slipcover', 'cover', 'protector', 'arm tray', 'armrest tray', 'caddy', 'riser', 'blanket', 'book', 'decal', 'sticker', 'poster', 'miniature', 'dollhouse', 'toy', 'pet bed', 'dog', 'cat', 'replacement'];
  /* Hard excludes and each level's own exclude list apply to every
     candidate, collection member or not (collections can contain strays,
     e.g. a desk clock in Office Desks). */
  var FOUNDATION_NOT_OUTDOOR = ['outdoor', 'patio', 'garden', 'porch', 'poolside'];
  var FOUNDATION_OUTDOOR_HARD = ['umbrella', 'cover', 'replacement', 'storage box', 'deck box', 'string light'];

  var FOUNDATION_CHAINS = {
    'living-room-collection': [
      { label: 'Sofa', noun: 'a sofa', collections: ['sofas'], keywords: ['sofa', 'sectional', 'couch', 'loveseat', 'love seat', 'chesterfield', 'settee'], exclude: ['bench', 'ottoman', 'chair'], hardExclude: FOUNDATION_NOT_OUTDOOR },
      { label: 'Accent Chair', noun: 'an accent chair', collections: ['accent-chairs'], keywords: ['accent chair', 'armchair', 'arm chair', 'lounge chair', 'club chair', 'barrel chair', 'swivel chair', 'slipper chair', 'wingback chair'], exclude: ['office', 'desk', 'dining', 'gaming', 'stool', 'chair cushion', 'seat cushion', 'chair pad', 'seat pad'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Accent Chair'] },
      { label: 'Coffee Table', noun: 'a coffee table', collections: [], keywords: ['coffee table', 'cocktail table', 'center table'], exclude: ['decor', 'decoration', 'sculpture', 'statue', 'figurine', 'centerpiece', 'vase', 'candle', 'ornament', 'bowl', 'coaster', 'plant'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Coffee Table'] }
    ],
    'bedroom-collection': [
      { label: 'Bed Frame', noun: 'a bed frame', collections: ['platform-beds'], keywords: ['bed frame', 'platform bed', 'upholstered bed', 'canopy bed', 'storage bed', 'panel bed', 'sleigh bed', 'poster bed', 'daybed'], exclude: ['bed rail', 'bed skirt', 'sheet', 'bedding', 'comforter', 'duvet', 'mattress topper', 'tent', 'curtain', 'mosquito net', 'bed risers', 'reading light', 'clip'], hardExclude: FOUNDATION_NOT_OUTDOOR },
      { label: 'Headboard', noun: 'a headboard', collections: ['headboards'], keywords: ['headboard'], exclude: ['bracket', 'mounting kit', 'hardware', 'reading light', 'wedge pillow', 'backrest pillow'], hardExclude: FOUNDATION_NOT_OUTDOOR },
      { label: 'Dresser', noun: 'a dresser', collections: ['bedroom-dressers'], keywords: ['dresser', 'chest of drawers'], exclude: ['organizer', 'knob', 'handle', 'scarf', 'runner', 'mirror only'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Dresser'] },
      { label: 'Nightstand', noun: 'a nightstand', collections: ['nightstands'], keywords: ['nightstand', 'night stand', 'bedside table'], exclude: ['table lamp', 'organizer', 'caddy'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Nightstand'] }
    ],
    'kitchen-collection': [
      { label: 'Dining Set', noun: 'a dining set', collections: ['dining-room'], requireAny: ['table', 'dinette'], requireAlso: ['set', 'piece', 'pcs', 'pc', 'chairs', 'bench'], keywords: ['dining set', 'dining table set', 'dining room set', 'dinette', 'kitchen table set', 'table and chairs', 'table and chair set', 'table with chairs', 'table with bench'], exclude: ['cloth', 'tablecloth', 'runner', 'placemat', 'place mat', 'coaster', 'napkin', 'dinnerware', 'flatware', 'silverware', 'cutlery', 'glass', 'plate', 'bowl', 'mug', 'toddler', 'kids'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Dining Chairs'] },
      { label: 'Dining Table', noun: 'a dining table', collections: ['dining-room'], requireAny: ['table'], keywords: ['dining table', 'kitchen table', 'pedestal table', 'farmhouse table', 'trestle table'], exclude: ['cloth', 'tablecloth', 'runner', 'placemat', 'place mat', 'pad', 'centerpiece', 'lamp', 'light', 'chandelier', 'pendant', 'coaster', 'napkin', 'mat', 'chair'], hardExclude: FOUNDATION_NOT_OUTDOOR },
      { label: 'Dining Chairs', noun: 'dining chairs', collections: ['dining-room'], requireAny: ['chair'], keywords: ['dining chair', 'kitchen chair', 'side chair'], exclude: ['chair cushion', 'seat cushion', 'chair pad', 'seat pad', 'office', 'desk', 'gaming', 'chair leg', 'leg cover'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Dining Chairs'] },
      { label: 'Bar Stools', noun: 'bar stools', collections: ['bar-stools'], keywords: ['bar stool', 'counter stool', 'barstool'], exclude: ['seat cushion', 'stool cushion', 'seat pad', 'stool cover'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Bar Stools'] }
    ],
    'office-furniture': [
      { label: 'Desk', noun: 'a desk', collections: ['modern-office-desk'], keywords: ['desk', 'writing table', 'computer table', 'workstation'], exclude: ['desk lamp', 'desk light', 'desk organizer', 'desk mat', 'desk pad', 'desk chair', 'accessory', 'converter', 'monitor arm', 'monitor riser', 'desk riser', 'fan', 'clock', 'calendar', 'cable', 'plant', 'decor', 'sign', 'nameplate', 'tidy', 'figurine', 'sculpture'], hardExclude: FOUNDATION_NOT_OUTDOOR },
      { label: 'Office Chair', noun: 'an office chair', collections: ['office-chairs'], keywords: ['office chair', 'desk chair', 'task chair', 'executive chair'], exclude: ['seat cushion', 'chair cushion', 'chair mat', 'caster wheel', 'replacement wheel', 'armrest pad'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Office Chair'] },
      { label: 'Bookcase', noun: 'a bookcase', collections: ['bookcases'], keywords: ['bookcase', 'bookshelf', 'book shelf', 'shelving unit', 'etagere', 'étagère'], exclude: ['bookend', 'wall shelf', 'wall shelves', 'floating shelf', 'floating shelves'], allow: ['book'], hardExclude: FOUNDATION_NOT_OUTDOOR, skip: ['Bookcase'] }
    ],
    'outdoor-furniture': [
      { label: 'Patio Set', noun: 'a patio set', collections: ['outdoor-furniture-sets'], keywords: ['patio set', 'patio furniture set', 'conversation set', 'bistro set', 'outdoor dining set', 'outdoor furniture set', 'patio dining set', 'sectional set', 'sofa set'], requireAny: ['conversation set', 'bistro set', 'dining set', 'furniture set', 'sofa set', 'sectional set', 'patio set', 'lounge set', 'piece', 'pcs', 'pc'], exclude: ['cushion cover', 'chairs set of', 'chair set of', 'chair set', 'set of 2 chairs', 'set of 4 chairs'], allow: ['throw pillow', 'pillows for'], hardExclude: FOUNDATION_OUTDOOR_HARD, skip: ['Outdoor Chair', 'Outdoor Coffee Table'] },
      { label: 'Patio Sofa', noun: 'a patio sofa', collections: ['outdoor-furniture-sets'], keywords: ['outdoor sofa', 'patio sofa', 'outdoor sectional', 'patio sectional', 'wicker sofa', 'rattan sofa', 'outdoor loveseat', 'patio loveseat', 'outdoor couch', 'patio couch'], requireAny: ['sofa', 'sectional', 'loveseat', 'love seat', 'couch'], exclude: ['replacement cushion', 'cushion cover'], hardExclude: FOUNDATION_OUTDOOR_HARD },
      { label: 'Patio Chair', noun: 'a patio chair', collections: ['outdoor-furniture-sets'], keywords: ['patio chair', 'outdoor chair', 'adirondack', 'outdoor lounge chair', 'patio lounge chair', 'chaise', 'outdoor rocking chair', 'patio rocking chair', 'egg chair', 'hanging chair', 'swing chair', 'porch swing'], requireAny: ['chair', 'chaise', 'lounger', 'rocker', 'swing'], exclude: ['replacement cushion', 'seat cushion', 'chair cushion', 'chair pad', 'cushion cover'], hardExclude: FOUNDATION_OUTDOOR_HARD, skip: ['Outdoor Chair'] },
      { label: 'Outdoor Table', noun: 'an outdoor table', collections: ['outdoor-furniture-sets'], keywords: ['outdoor coffee table', 'patio coffee table', 'outdoor side table', 'patio side table', 'patio table', 'outdoor table', 'outdoor dining table', 'patio dining table'], requireAny: ['table'], exclude: ['tablecloth', 'cloth'], allow: ['side table', 'end table'], hardExclude: FOUNDATION_OUTDOOR_HARD, skip: ['Outdoor Coffee Table'] }
    ]
  };

  var FOUNDATION_WORD_RE = {};
  function foundationWordRe(kw) {
    if (!FOUNDATION_WORD_RE[kw]) {
      /* Whole-word match; allows a plural "s"/"es" (sofa/sofas, bench/benches). */
      FOUNDATION_WORD_RE[kw] = new RegExp('(^|[^a-z])' + kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(e?s)?([^a-z]|$)');
    }
    return FOUNDATION_WORD_RE[kw];
  }

  function foundationHas(text, words) {
    return (words || []).some(function (kw) { return foundationWordRe(kw).test(text); });
  }

  function foundationText(p) {
    return p.titleText || String(p.title || '').toLowerCase();
  }

  function foundationCandidates(level, pool, poolsByCollection) {
    var member = {};
    (level.collections || []).forEach(function (handle) {
      ((poolsByCollection && poolsByCollection[handle]) || []).forEach(function (x) { member[x.handle] = true; });
    });
    var lookalikes = FOUNDATION_LOOKALIKES.filter(function (w) {
      return !(level.allow || []).some(function (a) { return w === a || a.indexOf(w) === 0; });
    });
    var seen = {};
    return pool.filter(function (p) {
      if (seen[p.handle]) return false;
      seen[p.handle] = true;
      var text = foundationText(p);
      if (foundationHas(text, level.hardExclude)) return false;
      if (foundationHas(text, level.exclude)) return false;
      if (!member[p.handle]) {
        if (!foundationHas(text, level.keywords)) return false;
        if (foundationHas(text, lookalikes)) return false;
      }
      if (level.requireAny && !foundationHas(text, level.requireAny)) return false;
      if (level.requireAlso && !foundationHas(text, level.requireAlso)) return false;
      return true;
    });
  }

  function foundationCollections(roomKey) {
    var out = [];
    (FOUNDATION_CHAINS[roomKey] || []).forEach(function (level) {
      (level.collections || []).forEach(function (h) { if (out.indexOf(h) === -1) out.push(h); });
    });
    return out;
  }

  function composeFoundation(slot, chain, styleProducts, poolsByCollection, usedHandles, randomize, skipSlots) {
    var levelIdx = -1;
    var candidates = [];
    var offStyle = false;
    var i;

    for (i = 0; i < chain.length; i++) {
      candidates = foundationCandidates(chain[i], styleProducts, poolsByCollection).filter(function (p) { return !usedHandles[p.handle]; });
      if (candidates.length) { levelIdx = i; break; }
    }

    if (levelIdx === -1) {
      /* Nothing in this style at any level: fall back to the category
         collections (any style), in the same order, and label it. */
      for (i = 0; i < chain.length; i++) {
        var union = [];
        (chain[i].collections || []).forEach(function (h) {
          union = union.concat((poolsByCollection && poolsByCollection[h]) || []);
        });
        candidates = foundationCandidates(chain[i], union, poolsByCollection).filter(function (p) { return !usedHandles[p.handle]; });
        if (candidates.length) { levelIdx = i; offStyle = true; break; }
      }
    }

    if (randomize) candidates = shuffle(candidates);

    var picked = [];
    for (i = 0; i < candidates.length && picked.length < slot.qty; i++) {
      picked.push(candidates[i]);
      usedHandles[candidates[i].handle] = true;
    }

    var note = '';
    if (levelIdx > -1) {
      (chain[levelIdx].skip || []).forEach(function (n) { skipSlots[n] = true; });
      var styleName = (STYLES[state.style] && STYLES[state.style].label) || 'this style';
      if (offStyle) {
        note = 'No ' + chain[0].label.toLowerCase() + ' tagged ' + styleName + ' is in stock right now — showing the closest match from our ' + chain[levelIdx].label.toLowerCase() + ' collection.';
      } else if (levelIdx > 0) {
        note = 'No ' + chain[0].label.toLowerCase() + ' tagged ' + styleName + ' is in stock right now — showing ' + chain[levelIdx].noun + ' instead.';
      }
    }

    return {
      slotName: slot.name,
      tier: slot.tier,
      items: picked,
      candidates: candidates,
      substituted: false,
      note: note,
      foundationLabel: levelIdx > -1 ? chain[levelIdx].label : slot.name,
      offStyle: offStyle
    };
  }

  var ROOM_RECIPES = {
    'bedroom-collection': { label: 'Bedroom', slots: [
      { name: 'Bed Frame', tier: 'primary', qty: 1, keywords: ['bed frame', 'platform bed'] },
      { name: 'Nightstand', tier: 'secondary', qty: 2, keywords: [], sourceCollection: 'nightstands' },
      { name: 'Dresser', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'bedroom-dressers' },
      { name: 'Bench or Chair', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'indoor-bench-collection', fallback: ['accent chair', 'armchair'], fallbackSourceCollection: 'accent-chairs' },
      { name: 'Area Rug', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'indoor-rugs' },
      { name: 'Table Lamp', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'table-lamps' },
      { name: 'Wall Art', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'wall-art' },
      { name: 'Decorative Accent', tier: 'accent', qty: 1, keywords: ['artificial plant', 'vase', 'decorative'], fallback: ['candle holder', 'tray', 'bowl'], exclude: FURNITURE_EXCLUDE }
    ]},
    'living-room-collection': { label: 'Living Room', slots: [
      { name: 'Sofa', tier: 'primary', qty: 1, keywords: ['sofa', 'sectional', 'couch', 'loveseat'] },
      { name: 'Coffee Table', tier: 'secondary', qty: 1, keywords: ['coffee table'], exclude: ['book', 'decor', 'sculpture', 'statue', 'figurine', 'tray', 'vase', 'candle', 'centerpiece', 'outdoor', 'patio'] },
      { name: 'Accent Chair', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'accent-chairs', fallback: ['ottoman'], fallbackSourceCollection: 'ottoman' },
      { name: 'Area Rug', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'indoor-rugs' },
      { name: 'Lighting', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'table-lamps' },
      { name: 'Wall Art', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'wall-art' },
      { name: 'Throw Pillow', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'throw-pillows-pillowcases' },
      { name: 'Decorative Accent', tier: 'accent', qty: 1, keywords: ['artificial plant', 'vase', 'decorative'], fallback: ['candle holder', 'tray', 'bowl'], exclude: FURNITURE_EXCLUDE }
    ]},
    'kitchen-collection': { label: 'Kitchen', slots: [
      { name: 'Dining Table', tier: 'primary', qty: 1, keywords: ['dining table'] },
      { name: 'Dining Chairs', tier: 'secondary', qty: 1, keywords: ['dining chair'], exclude: ['office chair', 'accent chair'] },
      { name: 'Bar Stools', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'bar-stools' },
      { name: 'Dinnerware', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'dinnerware' },
      { name: 'Tea Kettle', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'tea-pots-kettles' },
      { name: 'Decorative Accent', tier: 'accent', qty: 1, keywords: ['vase', 'decorative', 'runner'], fallback: ['candle holder', 'tray'], exclude: FURNITURE_EXCLUDE }
    ]},
    'bathroom-collection': { label: 'Bathroom', slots: [
      { name: 'Storage', tier: 'primary', qty: 1, keywords: ['storage cabinet', 'bathroom cabinet', 'medicine cabinet', 'linen cabinet', 'over the toilet'], fallback: ['bathroom shelf'], exclude: FURNITURE_EXCLUDE.concat(['kitchen cabinet', 'tv cabinet', 'file cabinet'], ACCESSORY_STORAGE_EXCLUDE) },
      { name: 'Bath Mat', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'bathroom-rugs' },
      { name: 'Shower Curtain', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'shower-curtain' },
      { name: 'Towels', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'bathroom-towels' },
      { name: 'Bathroom Essentials', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'bathroom-essentials' }
    ]},
    'office-furniture': { label: 'Home Office', slots: [
      { name: 'Desk', tier: 'primary', qty: 1, keywords: ['desk'] },
      { name: 'Office Chair', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'office-chairs' },
      { name: 'Bookcase', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'bookcases', fallback: ['shelving unit', 'open shelf'], fallbackSourceCollection: '__style__' },
      { name: 'Table Lamp', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'table-lamps' },
      { name: 'Wall Art', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'wall-art' },
      { name: 'Decorative Accent', tier: 'accent', qty: 1, keywords: ['vase', 'decorative', 'artificial plant'], fallback: ['candle holder', 'tray'], exclude: FURNITURE_EXCLUDE }
    ]},
    'outdoor-furniture': { label: 'Outdoor', slots: [
      { name: 'Patio Seating', tier: 'primary', qty: 1, keywords: ['outdoor sofa', 'patio sofa', 'outdoor sectional', 'patio sectional', 'wicker sofa'], exclude: ['outdoor chair', 'patio chair'] },
      { name: 'Outdoor Chair', tier: 'secondary', qty: 1, keywords: ['outdoor chair', 'patio chair', 'accent chair'], sourceCollection: 'outdoor-furniture' },
      { name: 'Water Fountain', tier: 'secondary', qty: 1, keywords: [], sourceCollection: 'indoor-outdoor-waterfountains' },
      { name: 'Outdoor Coffee Table', tier: 'secondary', qty: 1, keywords: ['outdoor coffee table', 'patio coffee table'], sourceCollection: 'outdoor-furniture' },
      { name: 'Fire Pit', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'fire-pits' },
      { name: 'Outdoor Storage', tier: 'accent', qty: 1, keywords: [], sourceCollection: 'outdoor-storage-boxes-patio-deck-boxes-amazon-finds' },
      { name: 'Outdoor Rug', tier: 'accent', qty: 1, keywords: ['outdoor rug'], sourceCollection: 'outdoor-furniture' },
      { name: 'Outdoor Decorative Pillow', tier: 'accent', qty: 1, keywords: ['outdoor pillow', 'outdoor throw pillow', 'outdoor decorative pillow'], sourceCollection: 'outdoor-furniture' }
    ]}
  };

  // Phase 5D: Mood Board room "recipe" keys (collection-handle style, used
  // by ROOM_RECIPES above and by every existing localStorage/URL-param path)
  // are distinct from the backend's canonical Project room keys. This map
  // is the single source of truth for that translation on this page. It is
  // used ONLY when talking to the cloud Projects API (MSGCloudProjects) --
  // every existing local code path keeps using the recipe key exactly as
  // before, unchanged.
  var ROOM_RECIPE_TO_PROJECT_ROOM = {
    'bedroom-collection': 'bedroom',
    'living-room-collection': 'livingroom',
    'kitchen-collection': 'kitchen',
    'bathroom-collection': 'bathroom',
    'office-furniture': 'homeoffice',
    'outdoor-furniture': 'outdoor'
  };

  var FREE_MAX_SAVED_BOARDS = 3;
  var AI_PLUS_MAX_SAVED_BOARDS = 20;
  var maxSavedBoards = FREE_MAX_SAVED_BOARDS;
  var currentTier = 'free';
  var entitlementUnavailable = false; // membership couldn't be checked
  // Signed-in customers start "pending": membership counts as confirmed only
  // once the check answers free or AI+, never by default (e.g. if something
  // stops the check from starting, Save still removes nothing).
  var entitlementPending = !!CUSTOMER_ID; // the membership check hasn't answered yet
  var lastSavedCount = null; // for re-rendering the Save note once the check answers
  var MEMBERSHIP_UNAVAILABLE_MSG = "We couldn't check your membership. Please try again";
  var MEMBERSHIP_PENDING_MSG = 'Checking your membership. Please try again in a moment';
  var LIST_FULL_MSG = 'Your saved list is full. Delete a saved item to make room. Your existing items are safe.';
  var LIST_UNREADABLE_MSG = 'We couldn’t read your saved list. Nothing was changed. Please try again.';

  var MAX_INSPIRATION = 3;
  var STORAGE_KEY = 'modernStudioMoodBoards';

  // Phase 4D.32: scope the "recently saved boards" quick-list by the
  // signed-in customer, matching the customer-scoping already used by
  // window.MSGProjects (see assets/studio-projects.js). CUSTOMER_ID is
  // read once above from data-mb-customer-id; a signed-out visitor gets
  // a distinct 'anonymous' namespace, so no customer's saved boards are
  // ever visible before sign-in, and nothing saved anonymously bleeds
  // into a signed-in customer's list. The pre-4D.32 global STORAGE_KEY
  // is left untouched on disk (never auto-read, never auto-deleted,
  // never merged) -- only this namespaced key is used going forward.
  function storageKey() {
    return STORAGE_KEY + ':' + (CUSTOMER_ID || 'anonymous');
  }

  var state = { room: null, style: null, colors: [], inspiration: [] };
  var slotResults = [];
  var lastStyleProducts = [];
  var lastDecorProducts = [];
  var lastPoolsByCollection = {};

  var roomGrid = root.querySelector('[data-mb-room-grid]');
  var styleGrid = root.querySelector('[data-mb-style-grid]');
  var buildStep = root.querySelector('[data-mb-step="build"]');
  var boardStep = root.querySelector('[data-mb-step="board"]');
  var colorRow = root.querySelector('[data-mb-colors]');
  var inspoForm = root.querySelector('[data-mb-inspo-form]');
  var inspoInput = root.querySelector('[data-mb-inspo-input]');
  var inspoList = root.querySelector('[data-mb-inspo-list]');
  var inspoHint = root.querySelector('[data-mb-inspo-hint]');
  var generateBtn = root.querySelector('[data-mb-generate]');
  var startOverBtn = root.querySelector('[data-mb-start-over]');
  var saveBtn = root.querySelector('[data-mb-save]');
  var saveNote = root.querySelector('[data-mb-save-note]');
  var regenerateBtn = root.querySelector('[data-mb-regenerate]');
  var regenerateNote = root.querySelector('[data-mb-regenerate-note]');
  var boardStyleName = root.querySelector('[data-mb-board-style-name]');
  var curationNote = root.querySelector('[data-mb-curation-note]');
  var boardColors = root.querySelector('[data-mb-board-colors]');
  var boardStory = root.querySelector('[data-mb-board-story]');
  var boardInspo = root.querySelector('[data-mb-board-inspo]');
  var boardPrimary = root.querySelector('[data-mb-board-primary]');
  var boardSecondary = root.querySelector('[data-mb-board-secondary]');
  var boardAccent = root.querySelector('[data-mb-board-accent]');
  var boardProductsLoading = root.querySelector('[data-mb-board-products-loading]');
  var planSpaceLink = root.querySelector('[data-mb-plan-space]');
  var savedList = root.querySelector('[data-mb-saved-list]');
  var savedWrap = root.querySelector('[data-mb-saved-wrap]');
  var projectBlock = root.querySelector('[data-mb-project-block]');
  var projectSelect = root.querySelector('[data-mb-project-select]');
  var projectNameInput = root.querySelector('[data-mb-project-name]');
  var projectAddBtn = root.querySelector('[data-mb-project-add]');
  var projectNote = root.querySelector('[data-mb-project-note]');
  var projectStorageNote = root.querySelector('[data-mb-project-storage-note]');

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function trackUse() {
    if (!API_BASE) return;
    try {
      fetch(API_BASE + '/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tool: 'mood-board' })
      }).catch(function () {});
    } catch (e) {}
  }

  function checkEntitlement() {
    // Phase 4D.17B: identity now comes from the Shopify App Proxy itself
    // (verified server-side), not a signed token built here -- no
    // customerId/issuedAt/token query string anymore. CUSTOMER_ID is kept
    // only as the client-side "is someone logged in" gate (see the section
    // file's comment); it is never sent to the proxy request below. A
    // logged-out visitor never had this attribute set, so this function
    // still makes no network call at all for anonymous visitors, exactly
    // as before.
    if (!CUSTOMER_ID) return; // signed out: no check, free rules as before
    if (!PROXY_PATH) { entitlementUnavailable = true; entitlementPending = false; return; } // can't check
    // Until the answer arrives, no upgrade offer is shown (see the
    // Save/Regenerate notes); the answer then decides.
    entitlementPending = true;
    fetch(PROXY_PATH)
      // A non-2xx reply is never a membership answer, whatever its body says.
      .then(function (res) { return res.json().then(function (body) { return res.ok ? body : null; }); })
      .then(function (data) {
        // Anything other than a clear free/AI+ answer means the membership
        // couldn't be checked: no upgrade offer (see the Save/Regenerate notes).
        entitlementUnavailable = !data || data.unavailable === true ||
          (data.tier !== 'ai_plus' && data.tier !== 'free');
        if (data && data.tier === 'ai_plus') {
          currentTier = 'ai_plus';
          maxSavedBoards = AI_PLUS_MAX_SAVED_BOARDS;
        }
        entitlementPending = false;
        updateRegenerateUi();
        updateProjectUi();
        refreshNotesAfterCheck();
      })
      .catch(function () {
        // Network failure or a reply that isn't JSON: same as unavailable.
        entitlementUnavailable = true;
        entitlementPending = false;
        updateRegenerateUi();
        refreshNotesAfterCheck();
      });
  }

  // A note shown while the check was pending is replaced by one that matches
  // the answer: the Save note is re-rendered, the Regenerate note is closed
  // (the next click shows the right one).
  // True once the check has answered free or AI+ (or for a signed-out visitor,
  // who is never checked). While pending, failed or unavailable it is false,
  // and Save never removes saved boards (see the Save handler).
  function membershipConfirmed() {
    return !CUSTOMER_ID || (!entitlementPending && !entitlementUnavailable);
  }

  function refreshNotesAfterCheck() {
    if (regenerateNote && !regenerateNote.hidden) regenerateNote.hidden = true;
    if (saveNote && !saveNote.hidden && lastSavedCount !== null) renderSaveNote(lastSavedCount);
  }

  function updateRegenerateUi() {
    if (!regenerateBtn) return;
    if (currentTier === 'ai_plus') {
      regenerateBtn.disabled = false;
      regenerateBtn.classList.remove('is-locked');
      if (regenerateNote) regenerateNote.hidden = true;
    } else {
      regenerateBtn.disabled = false;
      // Shown locked only once the check has confirmed a free customer.
      regenerateBtn.classList.toggle('is-locked', !entitlementUnavailable && !entitlementPending);
    }
  }

  function isCloudActive() {
    return !!window.MSGProjects &&
      typeof window.MSGProjects.hasCloudSnapshot === 'function' &&
      window.MSGProjects.hasCloudSnapshot();
  }

  function cloudRecovery() {
    return window.MSGCloudProjects && window.MSGCloudProjects.recovery
      ? window.MSGCloudProjects.recovery
      : null;
  }

  // Phase 6B #3: saving to THIS DEVICE (account saving off/unknown, a
  // browser Project opened, or no account view) goes through the shared
  // device saver in studio-projects.js; null if that file is older.
  var deviceSaver = window.MSGProjects && typeof window.MSGProjects.createDeviceToolSaver === 'function'
    ? window.MSGProjects.createDeviceToolSaver({
        item: 'board',
        field: 'moodBoard',
        roomKeys: function () { return [state.room, ROOM_RECIPE_TO_PROJECT_ROOM[state.room]]; },
        room: function () { return state.room; },
        roomLabel: function () { var r = ROOM_RECIPES[state.room]; return r ? r.label : state.room; },
        buildValue: function () { return buildBoardData(); },
        defaultName: function () { return defaultProjectName(); },
        select: projectSelect,
        nameInput: projectNameInput,
        addBtn: projectAddBtn,
        note: projectNote,
        storageNote: projectStorageNote
      })
    : null;

  function deviceSaveMode() {
    return deviceSaver && deviceSaver.mode() !== 'account';
  }

  // Phase 6B #3: 'livingroom' (Project room) -> 'living-room-collection'.
  function toRecipeRoom(room) {
    if (!room) return null;
    if (ROOM_RECIPES[room]) return room;
    var keys = Object.keys(ROOM_RECIPE_TO_PROJECT_ROOM);
    for (var i = 0; i < keys.length; i++) if (ROOM_RECIPE_TO_PROJECT_ROOM[keys[i]] === room) return keys[i];
    return null;
  }

  // Phase 6B #3: account saving was switched off during this visit (a
  // refused create). Switch to device saving and say nothing was saved.
  window.addEventListener('msg:account-writes-paused', function () {
    setTimeout(function () {
      updateProjectUi();
      if (projectNote) {
        projectNote.hidden = false;
        projectNote.textContent = 'Saving to your account is paused right now, so nothing was saved. Select “Add to Project” again to save it on this device.';
      }
    }, 0);
  });

  function updateProjectUi() {
    if (!projectBlock) return;
    projectBlock.hidden = currentTier !== 'ai_plus';
    if (currentTier === 'ai_plus') populateProjectSelect();
    // Phase 6A-4: the helper line says exactly when saving happens.
    var recovery = cloudRecovery();
    if (projectStorageNote && recovery && typeof recovery.storageNoteText === 'function') {
      projectStorageNote.textContent = recovery.storageNoteText('board', isCloudActive());
    }
    // Phase 6B #3: device saving explains itself (and relabels the button
    // when an account Project can only be saved as a copy on this device).
    if (deviceSaveMode() && state.room) deviceSaver.refreshUi();
  }

  function populateProjectSelect() {
    if (!projectSelect || !window.MSGProjects || !state.room) return;
    if (deviceSaveMode()) { deviceSaver.populate(); return; }

    var roomKey = state.room;
    if (typeof window.MSGProjects.hasCloudSnapshot === 'function' && window.MSGProjects.hasCloudSnapshot()) {
      roomKey = ROOM_RECIPE_TO_PROJECT_ROOM[state.room] || state.room;
    }
    // Phase 6A-4: rebuilding the list keeps the chosen Project selected
    // while it still exists for this room (same rule as Space Planner 6A-0b).
    var previousProjectId = projectSelect.value;
    var existing = window.MSGProjects.getProjectsForRoom(roomKey);
    var options = '<option value="">+ Start a new project</option>' +
      existing.map(function (p) {
        return '<option value="' + p.id + '">' + escapeHtml(p.name) + '</option>';
      }).join('');
    projectSelect.innerHTML = options;
    // Phase 6B #3: an account Project opened from My Projects is the target.
    var pre = !previousProjectId && deviceSaver && deviceSaver.accountPreselect ? deviceSaver.accountPreselect() : null;
    if (selectProjectOption(previousProjectId || pre) && pre) deviceSaver.markPreselectUsed();
  }

  // Phase 6A-4: selects projectId if it is in the list, otherwise
  // "+ Start a new project"; keeps the name field in sync.
  function selectProjectOption(projectId) {
    if (!projectSelect) return false;
    var found = !!projectId && Array.prototype.some.call(projectSelect.options, function (option) {
      return option.value === projectId;
    });
    projectSelect.value = found ? projectId : '';
    if (projectNameInput) projectNameInput.hidden = projectSelect.value !== '';
    return found;
  }

  function hydrateCloudProjects() {
    if (!CUSTOMER_ID) return Promise.resolve();
    if (!window.MSGCloudProjects || typeof window.MSGCloudProjects.listProjects !== 'function' || typeof window.MSGCloudProjects.listHomes !== 'function') return Promise.resolve();
    if (!window.MSGProjects || typeof window.MSGProjects.setCloudSnapshot !== 'function' ||
        typeof window.MSGProjects.clearCloudSnapshot !== 'function' ||
        typeof window.MSGProjects.getProjects !== 'function' ||
        typeof window.MSGProjects.getHomes !== 'function') return Promise.resolve();

    window.MSGProjects.clearCloudSnapshot();
    var localProjects = window.MSGProjects.getProjects() || [];
    var localHomes = window.MSGProjects.getHomes() || [];

    return Promise.all([
      window.MSGCloudProjects.listProjects(),
      window.MSGCloudProjects.listHomes()
    ]).then(function (results) {
      var projectsResult = results[0];
      var homesResult = results[1];

      var projectsOk = !!projectsResult && projectsResult.ok === true && Array.isArray(projectsResult.data);
      var homesOk = !!homesResult && homesResult.ok === true && Array.isArray(homesResult.data);
      if (!projectsOk || !homesOk) {
        // Phase 6B #3: account unreadable -> this device, status unknown.
        if (typeof window.MSGProjects.setAccountWrites === 'function') window.MSGProjects.setAccountWrites('unknown');
        return;
      }

      var cloudProjects = projectsResult.data;
      var cloudHomes = homesResult.data;

      // Phase 6B #3: same view rule as My Projects (studio-projects.js).
      if (typeof window.MSGProjects.decideCloudView === 'function') {
        var decision = window.MSGProjects.decideCloudView(projectsResult, homesResult);
        window.MSGProjects.setAccountWrites(decision.writes);
        if (!decision.activate) { updateProjectUi(); return; }
        window.MSGProjects.setCloudSnapshot(cloudProjects, cloudHomes, { writes: decision.writes });
        updateProjectUi();
        updateLocalOnlyLine();
        return;
      }

      if (cloudProjects.length === 0 && cloudHomes.length === 0 && (localProjects.length > 0 || localHomes.length > 0)) {
        return;
      }

      window.MSGProjects.setCloudSnapshot(cloudProjects, cloudHomes);
      updateProjectUi();
      updateLocalOnlyLine();
    }).catch(function () {
    });
  }

  // Phase 6B (D10): one quiet, text-only line when this browser still holds
  // Projects that are not in the account view. No import calls here.
  function updateLocalOnlyLine() {
    if (!projectBlock || !window.MSGProjects ||
        typeof window.MSGProjects.countLocalOnlyProjects !== 'function') return;
    var n = window.MSGProjects.countLocalOnlyProjects();
    var line = projectBlock.querySelector('[data-mb-project-local-only]');
    if (!n) {
      if (line) line.hidden = true;
      return;
    }
    if (!line) {
      line = document.createElement('p');
      line.className = 'mb-project-note mb-project-local-only';
      line.setAttribute('data-mb-project-local-only', '');
      var row = projectBlock.querySelector('.mb-project-row');
      if (row && row.parentNode) row.parentNode.insertBefore(line, row.nextSibling);
      else projectBlock.appendChild(line);
    }
    line.textContent = '';
    line.appendChild(document.createTextNode(n + (n === 1 ? ' Project is' : ' Projects are') + ' saved only in this browser. '));
    var a = document.createElement('a');
    a.href = '/pages/my-projects';
    // Phase 6B #3: moving is only possible while account saving is on.
    var canMove = typeof window.MSGProjects.getAccountWrites !== 'function' || window.MSGProjects.getAccountWrites() === 'on';
    a.textContent = canMove
      ? 'Move ' + (n === 1 ? 'it' : 'them') + ' in My Projects →'
      : 'View ' + (n === 1 ? 'it' : 'them') + ' in My Projects →';
    line.appendChild(a);
    line.hidden = false;
  }

  if (projectSelect) {
    projectSelect.addEventListener('change', function () {
      if (projectNameInput) projectNameInput.hidden = projectSelect.value !== '';
      // Phase 6A-4: choosing a different Project closes any open recovery
      // choice; the board itself is untouched.
      if (moodBoardSaver) moodBoardSaver.reset();
    });
  }

  function showProjectNote(html, isHtml) {
    if (!projectNote) return;
    projectNote.hidden = false;
    if (isHtml) {
      projectNote.innerHTML = html;
    } else {
      projectNote.textContent = html;
    }
  }

  function finishProjectAdd(project) {
    if (project) {
      showProjectNote('Added to "' + escapeHtml(project.name) + '." <a href="/pages/my-projects">View My Projects →</a>', true);
      if (projectNameInput) projectNameInput.value = '';
      populateProjectSelect();
      // Phase 6A-4: keep the saved Project (including a new one) selected,
      // so adding again updates it instead of creating a duplicate.
      selectProjectOption(project.id);
    } else {
      showProjectNote("We couldn't save this Project. Please try again.", false);
    }
  }

  // Phase 6A-4: the Mood Board currently on the page, in the shape stored
  // on a Project. savedAt is the time of this "Add to Project" action.
  function buildBoardData() {
    return {
      room: state.room,
      style: state.style,
      colors: state.colors,
      inspiration: state.inspiration,
      savedAt: Date.now()
    };
  }

  function summarizeBoard(board) {
    if (!board || typeof board !== 'object') return 'a Mood Board';
    var parts = [];
    var style = STYLES[board.style];
    var recipe = ROOM_RECIPES[board.room];
    parts.push(style ? style.label + ' style' : 'Mood Board');
    if (recipe) parts.push(recipe.label);
    var colorCount = Array.isArray(board.colors) ? board.colors.length : 0;
    if (colorCount) parts.push(colorCount + (colorCount === 1 ? ' color' : ' colors'));
    var inspoCount = Array.isArray(board.inspiration) ? board.inspiration.length : 0;
    if (inspoCount) parts.push(inspoCount + (inspoCount === 1 ? ' inspiration link' : ' inspiration links'));
    return parts.join(' · ');
  }

  function defaultProjectName() {
    var typed = projectNameInput && !projectNameInput.hidden ? (projectNameInput.value || '').trim() : '';
    if (typed) return typed;
    var s = STYLES[state.style];
    var recipe = ROOM_RECIPES[state.room];
    return (recipe ? recipe.label : 'Mood Board') + (s ? ' — ' + s.label : '');
  }

  // Phase 6A-4: cloud "Add to Project" goes through the shared
  // conflict-aware controller (assets/studio-cloud-projects.js). Created on
  // first use; null until then.
  var moodBoardSaver = null;

  function getMoodBoardSaver() {
    if (moodBoardSaver) return moodBoardSaver;
    var recovery = cloudRecovery();
    if (!recovery || typeof recovery.createToolSaver !== 'function') return null;
    moodBoardSaver = recovery.createToolSaver({
      field: 'moodBoard',
      label: 'Mood Board',
      item: 'board',
      noteEl: projectNote,
      addBtn: projectAddBtn,
      selectEl: projectSelect,
      buildValue: buildBoardData,
      summarize: summarizeBoard,
      defaultName: defaultProjectName,
      newProjectInput: function (name, boardData) {
        var recipe = ROOM_RECIPES[state.room];
        return {
          name: name,
          room: ROOM_RECIPE_TO_PROJECT_ROOM[state.room] || state.room,
          roomLabel: recipe ? recipe.label : state.room,
          moodBoard: boardData
        };
      },
      onSaved: finishProjectAdd,
      refreshProjectList: populateProjectSelect
    });
    return moodBoardSaver;
  }

  if (projectAddBtn) {
    projectAddBtn.addEventListener('click', function () {
      if (!window.MSGProjects) return;

      // Phase 6B #3: saving on this device (never an account write).
      if (deviceSaveMode()) {
        if (!state.room) return;
        deviceSaver.save();
        updateLocalOnlyLine();
        return;
      }

      if (isCloudActive()) {
        var saver = getMoodBoardSaver();
        if (!saver || typeof window.MSGProjects.getProject !== 'function') {
          finishProjectAdd(null);
          return;
        }
        saver.save();
        return;
      }

      // Browser-only Projects (unchanged).
      var s = STYLES[state.style];
      var recipe = ROOM_RECIPES[state.room];
      var boardData = buildBoardData();

      if (projectSelect.value) {
        finishProjectAdd(
          window.MSGProjects.attachMoodBoard(projectSelect.value, boardData)
        );
        return;
      }

      var name =
        (projectNameInput.value || '').trim() ||
        (recipe.label + ' — ' + s.label);

      var created =
        window.MSGProjects.createProject(name, state.room, recipe.label);

      finishProjectAdd(
        created
          ? window.MSGProjects.attachMoodBoard(created.id, boardData)
          : null
      );
    });
  }

  function renderRoomGrid() {
    if (!roomGrid) return;

    roomGrid.innerHTML = Object.keys(ROOM_RECIPES).map(function (key) {
      var r = ROOM_RECIPES[key];
      return '<button type="button" class="mb-room-chip" data-mb-room="' +
        key + '">' + r.label + '</button>';
    }).join('');

    Array.prototype.forEach.call(
      roomGrid.querySelectorAll('[data-mb-room]'),
      function (btn) {
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(
            roomGrid.querySelectorAll('[data-mb-room]'),
            function (b) {
              b.classList.remove('is-selected');
            }
          );

          btn.classList.add('is-selected');
          state.room = btn.getAttribute('data-mb-room');
          checkReady();
        });
      }
    );
  }

  function renderStyleGrid() {
    styleGrid.innerHTML = Object.keys(STYLES).map(function (key) {
      var s = STYLES[key];

      var chips = s.colors.slice(0, 5).map(function (hex) {
        return '<span class="palette-tile__chip" style="background:' +
          hex + '"></span>';
      }).join('');

      return '<button type="button" class="palette-tile" data-mb-style="' +
        key + '">' +
        '<span class="palette-tile__chips">' + chips + '</span>' +
        '<span class="palette-tile__label">' + s.label + '</span>' +
        '</button>';
    }).join('');

    Array.prototype.forEach.call(
      styleGrid.querySelectorAll('[data-mb-style]'),
      function (btn) {
        btn.addEventListener('click', function () {
          selectStyle(btn.getAttribute('data-mb-style'));
        });
      }
    );
  }

  function selectStyle(key) {
    var s = STYLES[key];
    if (!s) return;

    state.style = key;
    state.colors = s.colors.slice();

    Array.prototype.forEach.call(
      styleGrid.querySelectorAll('.palette-tile'),
      function (btn) {
        btn.classList.toggle(
          'is-selected',
          btn.getAttribute('data-mb-style') === key
        );
      }
    );

    renderColorRow();
    checkReady();
  }

  function renderColorRow() {
    if (!state.style) {
      colorRow.innerHTML = '';
      colorRow.hidden = true;
      return;
    }

    colorRow.hidden = false;

    var allColors = STYLES[state.style].colors;

    colorRow.innerHTML = allColors.map(function (hex) {
      var selected = state.colors.indexOf(hex) !== -1;

      return '<button type="button" class="mb-color-toggle' +
        (selected ? ' is-selected' : '') +
        '" data-mb-color="' + hex +
        '" style="background:' + hex +
        '" aria-label="' + hex + '"></button>';
    }).join('');

    Array.prototype.forEach.call(
      colorRow.querySelectorAll('[data-mb-color]'),
      function (btn) {
        btn.addEventListener('click', function () {
          var hex = btn.getAttribute('data-mb-color');
          var idx = state.colors.indexOf(hex);

          if (idx === -1) {
            state.colors.push(hex);
          } else if (state.colors.length > 1) {
            state.colors.splice(idx, 1);
          }

          renderColorRow();
        });
      }
    );
  }

  function searchProducts(q) {
    var url =
      '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=5' +
      '&resources[options][unavailable_products]=hide';

    return fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var found = (
          data.resources &&
          data.resources.results &&
          data.resources.results.products
        ) || [];
        return found.filter(function (p) {
          return !studioExcluded(p);
        });
      });
  }

  function renderInspoList() {
    inspoList.innerHTML = state.inspiration.map(function (p, i) {
      var img = p.image
        ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '">'
        : '';

      return '<div class="mb-inspo-item">' +
        img +
        '<span class="mb-inspo-item__title">' +
        escapeHtml(p.title) +
        '</span>' +
        '<button type="button" class="mb-inspo-item__remove" data-mb-remove-inspo="' +
        i +
        '" aria-label="Remove">&times;</button>' +
        '</div>';
    }).join('');

    Array.prototype.forEach.call(
      inspoList.querySelectorAll('[data-mb-remove-inspo]'),
      function (btn) {
        btn.addEventListener('click', function () {
          state.inspiration.splice(
            parseInt(btn.getAttribute('data-mb-remove-inspo'), 10),
            1
          );

          renderInspoList();
        });
      }
    );
  }

  if (inspoForm) {
    inspoForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var q = inspoInput.value.trim();

      if (!q) return;

      if (state.inspiration.length >= MAX_INSPIRATION) {
        inspoHint.textContent =
          'You can add up to ' +
          MAX_INSPIRATION +
          ' inspiration pieces.';

        inspoHint.hidden = false;
        return;
      }

      inspoHint.hidden = true;

      searchProducts(q).then(function (products) {
        if (products[0]) {
          state.inspiration.push(products[0]);
          renderInspoList();
        } else {
          inspoHint.textContent =
            'No product found for "' +
            q +
            '". Try different words.';

          inspoHint.hidden = false;
        }

        inspoInput.value = '';
      });
    });
  }

  function checkReady() {
    generateBtn.disabled = !(state.room && state.style);
  }

  // Sold-out products are never recommended: a product is kept only when at
  // least one of its variants is available for sale. Collections are paged
  // (250 per page, up to MAX_COLLECTION_PAGES) so filtering can't silently
  // leave a large collection short of in-stock candidates.
  var MAX_COLLECTION_PAGES = 4;

  // Shared exclusion rules (assets/studio-exclude.js): studio-exclude tag,
  // non-home types (guides, books, gift cards...) and non-decor types (appliances...).
  function studioExcluded(p) {
    return !!(window.MSGStudioExclude && window.MSGStudioExclude.isExcluded(p, 'design'));
  }

  function isAvailable(p) {
    return (p.variants || []).some(function (v) {
      return v.available;
    });
  }

  function fetchCollectionProducts(handle) {
    var all = [];
    function page(n) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
        .then(function (res) {
          return res.ok ? res.json() : { products: [] };
        })
        .then(function (data) {
          var batch = data.products || [];
          all = all.concat(batch.filter(function (p) {
            return isAvailable(p) && !studioExcluded(p);
          }));
          if (batch.length === 250 && n < MAX_COLLECTION_PAGES) return page(n + 1);
          return all;
        });
    }
    return page(1).catch(function () {
      return all;
    });
  }

  function mapProduct(p) {
    var variant = p.variants && p.variants[0];
    var price = variant ? parseFloat(variant.price) : 0;
    var image = p.images && p.images[0] ? p.images[0].src : '';
    var tagsLower = (p.tags || []).join(' ').toLowerCase();
    var typeLower = (p.product_type || '').toLowerCase();

    return {
      title: p.title,
      handle: p.handle,
      titleText: (p.title + ' ' + (p.product_type || '')).toLowerCase(),
      searchText:
        (p.title + ' ' + tagsLower + ' ' + typeLower).toLowerCase(),
      url: '/products/' + p.handle,
      price: price,
      image: image
    };
  }  function filterByKeywords(pool, keywords, exclude) {
    return pool.filter(function (p) {
      var matches = keywords.some(function (kw) {
        return p.searchText.indexOf(kw) !== -1;
      });

      if (!matches) return false;

      if (exclude && exclude.length) {
        var isExcluded = exclude.some(function (kw) {
          return p.searchText.indexOf(kw) !== -1;
        });

        if (isExcluded) return false;
      }

      return true;
    });
  }

  function excludeOnly(pool, exclude) {
    if (!exclude || !exclude.length) return pool.slice();

    return pool.filter(function (p) {
      return !exclude.some(function (kw) {
        return p.searchText.indexOf(kw) !== -1;
      });
    });
  }

  function shuffle(arr) {
    var a = arr.slice();

    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i];

      a[i] = a[j];
      a[j] = tmp;
    }

    return a;
  }

  function poolFor(key, poolsByCollection, styleProducts, decorProducts) {
    if (key === '__style__') return styleProducts;
    if (key === '__decor__') return decorProducts;

    return (poolsByCollection && poolsByCollection[key]) || [];
  }

  function composeBoard(
    styleProducts,
    decorProducts,
    poolsByCollection,
    recipe,
    randomize
  ) {
    var usedHandles = {};
    var results = [];

    var skipSlots = {};
    recipe.slots.forEach(function (slot) {
      /* The Foundation: room-specific priority chain (see FOUNDATION_CHAINS). */
      if (slot.tier === 'primary' && FOUNDATION_CHAINS[state.room]) {
        results.push(composeFoundation(slot, FOUNDATION_CHAINS[state.room], styleProducts, poolsByCollection, usedHandles, randomize, skipSlots));
        return;
      }
      /* Skip a supporting slot the foundation already covers (e.g. no second
         accent chair when the foundation fell back to an accent chair). */
      if (skipSlots[slot.name]) {
        results.push({ slotName: slot.name, tier: slot.tier, items: [], candidates: [], substituted: false });
        return;
      }
      var isDecor =
        DECOR_SLOT_NAMES.indexOf(slot.name) !== -1;

      var substituted = false;
      var candidates;

      if (slot.sourceCollection) {
        var sourcePool = poolFor(
          slot.sourceCollection,
          poolsByCollection,
          styleProducts,
          decorProducts
        );

        candidates =
          slot.keywords && slot.keywords.length
            ? filterByKeywords(
                sourcePool,
                slot.keywords,
                slot.exclude
              )
            : excludeOnly(
                sourcePool,
                slot.exclude
              );
      } else if (isDecor) {
        candidates = filterByKeywords(
          styleProducts,
          slot.keywords,
          slot.exclude
        );

        if (!candidates.length) {
          candidates = filterByKeywords(
            decorProducts,
            slot.keywords,
            slot.exclude
          );
        }
      } else {
        candidates = filterByKeywords(
          styleProducts,
          slot.keywords,
          slot.exclude
        );
      }

      if (
        !candidates.length &&
        slot.fallback &&
        slot.fallback.length
      ) {
        if (slot.fallbackSourceCollection) {
          var fallbackPool = poolFor(
            slot.fallbackSourceCollection,
            poolsByCollection,
            styleProducts,
            decorProducts
          );

          candidates = filterByKeywords(
            fallbackPool,
            slot.fallback,
            slot.exclude
          );
        } else if (slot.sourceCollection) {
          var samePool = poolFor(
            slot.sourceCollection,
            poolsByCollection,
            styleProducts,
            decorProducts
          );

          candidates = filterByKeywords(
            samePool,
            slot.fallback,
            slot.exclude
          );
        } else if (isDecor) {
          candidates = filterByKeywords(
            styleProducts,
            slot.fallback,
            slot.exclude
          );

          if (!candidates.length) {
            candidates = filterByKeywords(
              decorProducts,
              slot.fallback,
              slot.exclude
            );
          }
        } else {
          candidates = filterByKeywords(
            styleProducts,
            slot.fallback,
            slot.exclude
          );
        }

        substituted = candidates.length > 0;
      }

      var seen = {};

      candidates = candidates.filter(function (p) {
        if (seen[p.handle]) return false;

        seen[p.handle] = true;
        return true;
      });

      if (randomize) {
        candidates = shuffle(candidates);
      }

      var picked = [];

      for (
        var i = 0;
        i < candidates.length && picked.length < slot.qty;
        i++
      ) {
        if (usedHandles[candidates[i].handle]) continue;

        picked.push(candidates[i]);
        usedHandles[candidates[i].handle] = true;
      }

      results.push({
        slotName: slot.name,
        tier: slot.tier,
        items: picked,
        candidates: candidates,
        substituted: substituted
      });
    });

    return results;
  }

  function cardHtml(p, tier) {
    var imgSrc = p.image
      ? p.image +
        '&width=' +
        (
          tier === 'primary'
            ? 700
            : tier === 'secondary'
              ? 500
              : 350
        )
      : '';

    var titleAttr =
      p.title.replace(/"/g, '&quot;');

    return '<div class="mb-piece mb-piece--' +
      tier +
      '">' +
      '<a href="' +
      p.url +
      '" class="mb-piece__link">' +
      '<div class="mb-piece__image">' +
      (
        imgSrc
          ? '<img src="' +
            imgSrc +
            '" loading="lazy" alt="' +
            titleAttr +
            '">'
          : ''
      ) +
      '</div>' +
      '<div class="mb-piece__title">' +
      escapeHtml(p.title) +
      '</div>' +
      '<div class="mb-piece__price">' +
      (
        p.price
          ? '$' + p.price.toFixed(2)
          : ''
      ) +
      '</div>' +
      '</a>' +
      '<button type="button" class="mb-piece__replace" data-mb-replace aria-label="Replace this piece">Replace →</button>' +
      '</div>';
  }

  function renderSection(el, tierLabel, tier) {
    var slotsForTier = slotResults.filter(function (s) {
      return s.tier === tier && s.items.length;
    });

    if (!slotsForTier.length) {
      if (tier === 'primary') {
        el.hidden = false;

        el.innerHTML =
          '<p class="mb-board-section-label">' +
          tierLabel +
          '</p>' +
          '<p class="mb-foundation-empty">We don’t currently have an item that fits this description in stock. Check back again soon — we’re always adding new products.</p>';
      } else {
        el.innerHTML = '';
        el.hidden = true;
      }

      return;
    }

    el.hidden = false;

    el.innerHTML =
      '<p class="mb-board-section-label">' +
      tierLabel +
      '</p>' +
      '<div class="mb-piece-grid mb-piece-grid--' +
      tier +
      '">' +
      slotsForTier.map(function (slotResult) {
        var subNote =
          (slotResult.note || slotResult.substituted)
            ? '<span class="mb-piece__sub-note">' +
              escapeHtml(slotResult.note || ('Substituted for ' + slotResult.slotName)) +
              '</span>'
            : '';

        return slotResult.items.map(function (item, idx) {
          return '<div data-mb-slot-item data-slot="' +
            slotResult.slotName +
            '" data-idx="' +
            idx +
            '">' +
            cardHtml(item, tier) +
            subNote +
            '</div>';
        }).join('');
      }).join('');

    el.innerHTML += '</div>';

    Array.prototype.forEach.call(
      el.querySelectorAll('[data-mb-replace]'),
      function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();

          var wrap =
            btn.closest('[data-mb-slot-item]');

          var slotName =
            wrap.getAttribute('data-slot');

          var idx =
            parseInt(
              wrap.getAttribute('data-idx'),
              10
            );

          replaceItem(slotName, idx);
        });
      }
    );
  }

  function replaceItem(slotName, idx) {
    var slotResult =
      slotResults.filter(function (s) {
        return s.slotName === slotName;
      })[0];

    if (
      !slotResult ||
      !slotResult.candidates.length
    ) return;

    var currentHandles =
      slotResult.items.map(function (p) {
        return p.handle;
      });

    var currentHandle =
      currentHandles[idx];

    var currentPos =
      slotResult.candidates.map(function (p) {
        return p.handle;
      }).indexOf(currentHandle);

    for (
      var step = 1;
      step <= slotResult.candidates.length;
      step++
    ) {
      var nextPos =
        (currentPos + step) %
        slotResult.candidates.length;

      var candidate =
        slotResult.candidates[nextPos];

      if (
        currentHandles.indexOf(candidate.handle) === -1
      ) {
        slotResult.items[idx] = candidate;
        renderBoardSections();
        return;
      }
    }
  }

  function renderBoardSections() {
    renderSection(
      boardPrimary,
      'The Foundation',
      'primary'
    );

    renderSection(
      boardSecondary,
      'Supporting Pieces',
      'secondary'
    );

    renderSection(
      boardAccent,
      'Finishing Touches',
      'accent'
    );
  }

  function renderBoard() {
    trackUse();

    var s = STYLES[state.style];
    var recipe = ROOM_RECIPES[state.room];

    boardStyleName.textContent =
      recipe.label + ' — ' + s.label;

    if (curationNote) {
      curationNote.textContent =
        'Curated by Môdern Studio™ design logic — real products matched using structured room and style rules, based on what’s currently available from Amazon and other sellers. Full AI-powered design reasoning is coming in a future update.';
    }

    boardColors.innerHTML =
      state.colors.map(function (hex) {
        return '<div class="palette-swatch">' +
          '<div class="palette-swatch__color" style="background:' +
          hex +
          '"></div>' +
          '<div class="palette-swatch__hex">' +
          hex.toUpperCase() +
          '</div></div>';
      }).join('');

    boardStory.innerHTML =
      '<p class="mb-board-section-label" style="margin-top:0;">About This Style</p>' +
      '<p class="mb-story-text">' +
      s.story +
      '</p>';

    if (state.inspiration.length) {
      boardInspo.hidden = false;

      boardInspo.innerHTML =
        '<p class="mb-board-section-label">Your Inspiration</p>' +
        '<div class="mb-inspo-list">' +
        state.inspiration.map(function (p) {
          var img = p.image
            ? '<img src="' +
              p.image +
              '" alt="' +
              escapeHtml(p.title) +
              '">'
            : '';

          return '<a class="mb-inspo-item" href="' +
            p.url +
            '">' +
            img +
            '<span class="mb-inspo-item__title">' +
            escapeHtml(p.title) +
            '</span></a>';
        }).join('') +
        '</div>';
    } else {
      boardInspo.hidden = true;
      boardInspo.innerHTML = '';
    }

    boardPrimary.innerHTML = '';
    boardSecondary.innerHTML = '';
    boardAccent.innerHTML = '';

    boardProductsLoading.hidden = false;

    var needsDecor =
      recipe.slots.some(function (slot) {
        return (
          DECOR_SLOT_NAMES.indexOf(slot.name) !== -1 &&
          !slot.sourceCollection
        );
      });

    var collectionsToFetch = {};
    foundationCollections(state.room).forEach(function (h) { collectionsToFetch[h] = true; });

    recipe.slots.forEach(function (slot) {
      if (
        slot.sourceCollection &&
        slot.sourceCollection !== '__style__' &&
        slot.sourceCollection !== '__decor__'
      ) {
        collectionsToFetch[
          slot.sourceCollection
        ] = true;
      }

      if (
        slot.fallbackSourceCollection &&
        slot.fallbackSourceCollection !== '__style__' &&
        slot.fallbackSourceCollection !== '__decor__'
      ) {
        collectionsToFetch[
          slot.fallbackSourceCollection
        ] = true;
      }
    });

    var sourceCollections =
      Object.keys(collectionsToFetch);

    var fetchPlan = [
      {
        key: '__style__',
        handle: s.collection
      }
    ];

    if (needsDecor) {
      fetchPlan.push({
        key: '__decor__',
        handle: HOME_DECOR_HANDLE
      });
    }

    sourceCollections.forEach(function (handle) {
      fetchPlan.push({
        key: handle,
        handle: handle
      });
    });

    Promise.all(
      fetchPlan.map(function (f) {
        return fetchCollectionProducts(f.handle);
      })
    ).then(function (results) {
      boardProductsLoading.hidden = true;

      var poolsByCollection = {};

      fetchPlan.forEach(function (f, i) {
        var mapped =
          results[i].map(mapProduct);

        if (f.key === '__style__') {
          lastStyleProducts = mapped;
        } else if (f.key === '__decor__') {
          lastDecorProducts = mapped;
        } else {
          poolsByCollection[f.key] = mapped;
        }
      });

      lastPoolsByCollection =
        poolsByCollection;

      slotResults =
        composeBoard(
          lastStyleProducts,
          lastDecorProducts,
          poolsByCollection,
          recipe,
          false
        );

      renderBoardSections();
    });

    if (planSpaceLink) {
      planSpaceLink.href =
        '/pages/space-planner?room=' +
        encodeURIComponent(state.room);

      planSpaceLink.hidden = false;
    }

    buildStep.hidden = true;
    boardStep.hidden = false;
    saveNote.hidden = true;

    if (regenerateNote) {
      regenerateNote.hidden = true;
    }

    if (projectNote) {
      projectNote.hidden = true;
    }

    // Phase 6A-4: a new board closes any open recovery choice for the old one.
    if (moodBoardSaver) moodBoardSaver.reset();

    updateRegenerateUi();
    updateProjectUi();
  }  generateBtn.addEventListener(
    'click',
    renderBoard
  );

  if (regenerateBtn) {
    regenerateBtn.addEventListener(
      'click',
      function () {
        if ((entitlementUnavailable || entitlementPending) && currentTier !== 'ai_plus') {
          if (regenerateNote) { regenerateNote.hidden = false; regenerateNote.textContent = entitlementPending ? MEMBERSHIP_PENDING_MSG : MEMBERSHIP_UNAVAILABLE_MSG; }
          return;
        }
        if (currentTier !== 'ai_plus') {
          if (regenerateNote) {
            regenerateNote.hidden = false;

            regenerateNote.innerHTML =
              CUSTOMER_ID
                ? '✨ Regenerate Board is an AI+ feature. <a href="' +
                  UPGRADE_URL +
                  '">Upgrade to AI+</a> to get a fresh composition for this room and style.'
                : '✨ Regenerate Board is an AI+ feature. <a href="/account/login">Sign in</a> and <a href="' +
                  UPGRADE_URL +
                  '">upgrade to AI+</a> to get a fresh composition for this room and style.';
          }

          return;
        }

        if (regenerateNote) {
          regenerateNote.hidden = true;
        }

        var recipe =
          ROOM_RECIPES[state.room];

        if (
          !recipe ||
          !lastStyleProducts.length
        ) return;

        slotResults =
          composeBoard(
            lastStyleProducts,
            lastDecorProducts,
            lastPoolsByCollection,
            recipe,
            true
          );

        renderBoardSections();
      }
    );
  }

  startOverBtn.addEventListener(
    'click',
    function () {
      // Phase 6A-4: starting over closes any open recovery choice.
      if (moodBoardSaver) moodBoardSaver.reset();

      state = {
        room: null,
        style: null,
        colors: [],
        inspiration: []
      };

      slotResults = [];

      if (roomGrid) {
        Array.prototype.forEach.call(
          roomGrid.querySelectorAll(
            '.mb-room-chip'
          ),
          function (btn) {
            btn.classList.remove(
              'is-selected'
            );
          }
        );
      }

      Array.prototype.forEach.call(
        styleGrid.querySelectorAll(
          '.palette-tile'
        ),
        function (btn) {
          btn.classList.remove(
            'is-selected'
          );
        }
      );

      renderColorRow();
      renderInspoList();

      inspoHint.hidden = true;

      checkReady();

      boardStep.hidden = true;
      buildStep.hidden = false;
    }
  );

  // Reads the saved list without ever changing it.
  // - Nothing stored yet: { ok: true, list: [] } (an empty list).
  // - Stored value that can't be read, parsed, or isn't a list of saved
  //   boards (objects): { ok: false }. Save and Delete then do nothing and
  //   show LIST_UNREADABLE_MSG, so the stored value is never overwritten,
  //   cleared or reset. Once it is readable again, everything works as usual.
  function readSavedBoards() {
    var raw;
    try {
      raw = localStorage.getItem(storageKey());
    } catch (e) {
      return { ok: false };
    }
    if (raw === null) return { ok: true, list: [] };
    var list;
    try {
      list = JSON.parse(raw);
    } catch (e) {
      return { ok: false };
    }
    if (!Array.isArray(list)) return { ok: false };
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (!b || typeof b !== 'object' || Array.isArray(b)) return { ok: false };
      // Fields the page uses as lists must be lists (or absent).
      if (b.colors != null && !Array.isArray(b.colors)) return { ok: false };
      if (b.inspiration != null && !Array.isArray(b.inspiration)) return { ok: false };
    }
    return { ok: true, list: list };
  }

  function showListUnreadableNote() {
    lastSavedCount = null; // nothing was saved; the note isn't re-rendered later
    saveNote.hidden = false;
    saveNote.textContent = LIST_UNREADABLE_MSG;
  }

  function persistSavedBoards(boards) {
    try {
      localStorage.setItem(
        storageKey(),
        JSON.stringify(boards)
      );
    } catch (e) {}
  }

  function renderSavedBoards() {
    var read = readSavedBoards();

    if (!read.ok) {
      // Unreadable: say so where the list would be; nothing can be loaded or
      // deleted until it is readable again.
      savedWrap.hidden = false;
      savedList.innerHTML =
        '<p class="mb-save-note" data-mb-saved-unreadable>' +
        escapeHtml(LIST_UNREADABLE_MSG) +
        '</p>';
      return;
    }

    var boards = read.list;

    if (!boards.length) {
      savedWrap.hidden = true;
      return;
    }

    savedWrap.hidden = false;

    savedList.innerHTML =
      boards.map(function (b, i) {
        var chips =
          (b.colors || [])
            .slice(0, 5)
            .map(function (hex) {
              return '<span class="palette-tile__chip" style="background:' +
                hex +
                '"></span>';
            })
            .join('');

        var roomLabel =
          ROOM_RECIPES[b.room]
            ? ROOM_RECIPES[b.room].label
            : '';

        return '<div class="mb-saved-item-wrap">' +
          '<button type="button" class="mb-saved-item" data-mb-load="' +
          i +
          '">' +
          '<span class="palette-tile__chips">' +
          chips +
          '</span>' +
          '<span class="palette-tile__label">' +
          escapeHtml(roomLabel) +
          ' · ' +
          escapeHtml(
            STYLES[b.style]
              ? STYLES[b.style].label
              : b.style
          ) +
          '</span>' +
          '</button>' +
          '<button type="button" class="mb-saved-item__delete" data-mb-delete="' +
          i +
          '" aria-label="Delete this mood board">&times;</button>' +
          '</div>';
      }).join('');

    Array.prototype.forEach.call(
      savedList.querySelectorAll(
        '[data-mb-load]'
      ),
      function (btn) {
        btn.addEventListener(
          'click',
          function () {
            var b =
              boards[
                parseInt(
                  btn.getAttribute(
                    'data-mb-load'
                  ),
                  10
                )
              ];

            if (!b) return;

            state = {
              room: b.room,
              style: b.style,
              colors: (b.colors || []).slice(),
              inspiration:
                b.inspiration || []
            };

            renderInspoList();
            renderBoard();
          }
        );
      }
    );

    Array.prototype.forEach.call(
      savedList.querySelectorAll(
        '[data-mb-delete]'
      ),
      function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.stopPropagation();

            var idx =
              parseInt(
                btn.getAttribute(
                  'data-mb-delete'
                ),
                10
              );

            var target =
              boards[idx];

            // Don't ask to confirm a delete that can't happen.
            if (!readSavedBoards().ok) {
              renderSavedBoards();
              showListUnreadableNote();
              return;
            }

            var label =
              target
                ? (
                    (
                      ROOM_RECIPES[
                        target.room
                      ]
                        ? ROOM_RECIPES[
                            target.room
                          ].label
                        : 'this'
                    ) +
                    ' — ' +
                    (
                      STYLES[
                        target.style
                      ]
                        ? STYLES[
                            target.style
                          ].label
                        : target.style
                    )
                  )
                : 'this mood board';

            if (
              !window.confirm(
                'Delete "' +
                label +
                '"? This cannot be undone.'
              )
            ) return;

            // Remove exactly the board that was clicked, from the list as it
            // is stored now (another tab may have changed it since it was
            // drawn), so no other saved board is lost.
            var currentRead = readSavedBoards();
            if (!currentRead.ok) {
              // Became unreadable while the dialog was open: change nothing.
              renderSavedBoards();
              showListUnreadableNote();
              return;
            }
            var current = currentRead.list;
            var targetJson = JSON.stringify(target);
            var at = -1;
            for (var k = 0; k < current.length; k++) {
              if (JSON.stringify(current[k]) === targetJson) { at = k; break; }
            }
            if (at !== -1) {
              current.splice(at, 1);
              persistSavedBoards(current);
            }
            renderSavedBoards();

            // A "list full" note no longer applies once there is room; a
            // "Saved to this browser — N…" note is redrawn with the new count.
            if (saveNote && saveNote.textContent === LIST_FULL_MSG) {
              if (!(membershipConfirmed() && current.length >= maxSavedBoards)) {
                saveNote.hidden = true;
              }
            } else if (saveNote && !saveNote.hidden && lastSavedCount !== null) {
              renderSaveNote(current.length);
            }
          }
        );
      }
    );
  }

  saveBtn.addEventListener(
    'click',
    function () {
      var read = readSavedBoards();
      if (!read.ok) {
        // Unreadable saved list: write nothing; the board on screen stays.
        renderSavedBoards();
        showListUnreadableNote();
        return;
      }
      var boards = read.list;

      // Full-list rule: saved boards are never removed by saving. Once the
      // plan limit is known (membership confirmed, or a signed-out visitor),
      // a list at or above it blocks adding another board; nothing is
      // written. While membership is pending, failed or unavailable the new
      // board is added and nothing is removed.
      if (
        membershipConfirmed() &&
        boards.length >=
        maxSavedBoards
      ) {
        // Redraw the list first (it may still show an older "couldn't read"
        // notice), so every board can be seen and deleted to make room.
        renderSavedBoards();
        showListFullNote();
        return;
      }

      boards.unshift({
        room: state.room,
        style: state.style,
        colors: state.colors,
        inspiration: state.inspiration,
        savedAt: Date.now()
      });

      persistSavedBoards(boards);
      renderSavedBoards();

      renderSaveNote(boards.length);
    }
  );

  function showListFullNote() {
    lastSavedCount = null; // nothing was saved; the note isn't re-rendered later
    saveNote.hidden = false;
    saveNote.textContent = LIST_FULL_MSG;
  }

  function renderSaveNote(count) {
    lastSavedCount = count;
    saveNote.hidden = false;

    // The upgrade link appears only once the check has confirmed a free
    // customer; while it's pending or unavailable a short status is shown.
    var membershipKnown = !entitlementPending && !entitlementUnavailable;

    var limitNote =
      currentTier === 'ai_plus' || !membershipKnown
        ? ''
        : ' Upgrade to AI+ for up to ' +
          AI_PLUS_MAX_SAVED_BOARDS +
          ' saved boards.';

    var statusNote =
      currentTier === 'ai_plus' || membershipKnown
        ? ''
        : ' ' + (entitlementPending ? MEMBERSHIP_PENDING_MSG : MEMBERSHIP_UNAVAILABLE_MSG);

    // "N of limit" only when the limit is known and the list is within it;
    // otherwise just the count (nothing was removed).
    var countText =
      membershipKnown && count <= maxSavedBoards
        ? count + ' of ' + maxSavedBoards + ' mood boards saved.'
        : count + (count === 1 ? ' mood board' : ' mood boards') + ' saved.';

    saveNote.innerHTML =
      'Saved to this browser — you have ' +
      countText +
      (
        limitNote
          ? ' <a href="' +
            UPGRADE_URL +
            '">' +
            limitNote.trim() +
            '</a>'
          : ''
      ) +
      escapeHtml(statusNote);
  }

  renderRoomGrid();
  renderStyleGrid();
  renderSavedBoards();
  checkReady();
  checkEntitlement();
  updateRegenerateUi();

  // Phase 5D: applyQueryParams() can resolve a ?project=<id> against
  // a cloud Project via MSGProjects.getProject(), so it must not run until
  // hydrateCloudProjects() has either activated a cloud snapshot or
  // determined none applies. checkEntitlement() stays independent and
  // asynchronous as before.
  hydrateCloudProjects().then(function () {
    applyQueryParams();
  });

  function applyQueryParams() {
    try {
      var params =
        new URLSearchParams(
          window.location.search
        );

      var pid =
        params.get('project');

      var restored = false;

      if (
        pid &&
        window.MSGProjects
      ) {
        // Phase 6B #3: a saved=device link reads only THIS customer's
        // browser copy; the opened record decides where saves go.
        var opened = typeof window.MSGProjects.resolveOpenedProject === 'function'
          ? window.MSGProjects.resolveOpenedProject(pid, params.get('saved'))
          : null;

        var proj = opened
          ? opened.project
          : (typeof window.MSGProjects.resolveOpenedProject === 'function' ? null : window.MSGProjects.getProject(pid));

        if (deviceSaver) deviceSaver.setOpened(opened);

        if (
          proj &&
          proj.moodBoard
        ) {
          restored = true;

          var mb =
            proj.moodBoard;

          var roomToUse =
            (
              mb.room &&
              ROOM_RECIPES[mb.room]
            )
              ? mb.room
              : (
                  proj.room &&
                  ROOM_RECIPES[proj.room]
                )
                ? proj.room
                : null;

          if (roomToUse) {
            var roomTile =
              roomGrid.querySelector(
                '[data-mb-room="' +
                roomToUse +
                '"]'
              );

            if (roomTile) {
              roomTile.click();
            }
          }

          var styleToUse =
            (
              mb.style &&
              STYLES[mb.style]
            )
              ? mb.style
              : null;

          if (styleToUse) {
            selectStyle(
              styleToUse
            );

            if (
              mb.colors &&
              mb.colors.length
            ) {
              var validColors =
                mb.colors.filter(
                  function (hex) {
                    return (
                      typeof hex ===
                        'string' &&
                      STYLES[
                        styleToUse
                      ].colors.indexOf(
                        hex
                      ) !== -1
                    );
                  }
                );

              if (
                validColors.length
              ) {
                state.colors =
                  validColors;

                renderColorRow();
              }
            }
          }

          if (
            mb.inspiration &&
            mb.inspiration.length
          ) {
            mb.inspiration.forEach(
              function (item) {
                if (
                  state.inspiration.length <
                    MAX_INSPIRATION &&
                  item &&
                  typeof item.title ===
                    'string' &&
                  item.title.trim() &&
                  typeof item.url ===
                    'string' &&
                  item.url.trim()
                ) {
                  state.inspiration.push(
                    item
                  );
                }
              }
            );

            if (
              state.inspiration.length
            ) {
              renderInspoList();
            }
          }
        }
      }

      if (!restored) {
        // Phase 6B #3: an opened Project without a board (empty panel link)
        // still sets its room; account rooms use the Project room keys.
        var roomParam =
          toRecipeRoom(params.get('room')) ||
          toRecipeRoom(deviceSaver && deviceSaver.openedRoom ? deviceSaver.openedRoom() : null);

        if (
          roomParam &&
          ROOM_RECIPES[
            roomParam
          ]
        ) {
          var matchingTile =
            roomGrid.querySelector(
              '[data-mb-room="' +
              roomParam +
              '"]'
            );

          if (matchingTile) {
            matchingTile.click();
          }
        }

        var styleParam =
          params.get('style');

        if (
          styleParam &&
          STYLES[styleParam]
        ) {
          selectStyle(
            styleParam
          );
        }

        var q =
          params.get(
            'inspiration'
          );

        if (q) {
          searchProducts(q)
            .then(
              function (products) {
                if (
                  products[0] &&
                  state.inspiration.length <
                    MAX_INSPIRATION
                ) {
                  state.inspiration.push(
                    products[0]
                  );

                  renderInspoList();
                }
              }
            );
        }
      }
    } catch (e) {
      // no-op
    }
  }

})();